import React from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "../data/siteConfig";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0f1419] border-t border-white/10 footer-spacing">
      <div className="container-custom">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10 md:gap-12 py-2">
          <div>
            <Link
              to="/"
              className="inline-block mb-4 focus:outline-none focus:ring-2 focus:ring-white/30 rounded"
              aria-label="Marmoris Startseite"
            >
              <img
                src={`${process.env.PUBLIC_URL || ""}/logo-white.svg`}
                alt="Marmoris – Digital Marketing & Social Media Agentur Kärnten"
                className="h-9 w-auto md:h-10"
              />
            </Link>
            <p className="text-white/70 text-sm leading-relaxed max-w-xs">
              Digital Marketing und Social Media für Unternehmen in Österreich.
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-base">Marketing</h3>
            <nav className="space-y-3" aria-label="Marketing">
              <Link to={ROUTES.digitaleVermarktung} className="block text-white/60 hover:text-[#4a9da8] text-sm transition-colors w-fit">
                Digitale Vermarktung
              </Link>
              <Link to={ROUTES.socialMediaMarketing} className="block text-white/60 hover:text-[#4a9da8] text-sm transition-colors w-fit">
                Social Media Marketing
              </Link>
              <Link to={ROUTES.onlineMarketingUnternehmen} className="block text-white/60 hover:text-[#4a9da8] text-sm transition-colors w-fit">
                Online-Marketing für Unternehmen
              </Link>
              <Link to={ROUTES.digitaleMarkenpraesenz} className="block text-white/60 hover:text-[#4a9da8] text-sm transition-colors w-fit">
                Digitale Markenpräsenz
              </Link>
              <Link to="/#leistungen" className="block text-white/60 hover:text-[#4a9da8] text-sm transition-colors w-fit">
                Alle Leistungen
              </Link>
            </nav>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-base">Websites & Branding</h3>
            <nav className="space-y-3" aria-label="Websites & Branding">
              <Link to={ROUTES.websitesUnternehmen} className="block text-white/60 hover:text-[#4a9da8] text-sm transition-colors w-fit">
                Websites für Unternehmen
              </Link>
              <Link to={ROUTES.serviceWebdesign} className="block text-white/60 hover:text-[#4a9da8] text-sm transition-colors w-fit">
                Webdesign
              </Link>
              <Link to={ROUTES.serviceBranding} className="block text-white/60 hover:text-[#4a9da8] text-sm transition-colors w-fit">
                Branding
              </Link>
              <Link to={ROUTES.serviceCorporateDesign} className="block text-white/60 hover:text-[#4a9da8] text-sm transition-colors w-fit">
                Corporate Design
              </Link>
              <Link to="/#kontakt" className="block text-white/60 hover:text-[#4a9da8] text-sm transition-colors w-fit">
                Kontakt
              </Link>
            </nav>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-base">Regionen</h3>
            <nav className="space-y-3" aria-label="Regionen">
              <Link to={ROUTES.marketingKaernten} className="block text-white/60 hover:text-[#4a9da8] text-sm transition-colors w-fit">
                Marketing Agentur Kärnten
              </Link>
              <Link to={ROUTES.socialMediaKlagenfurt} className="block text-white/60 hover:text-[#4a9da8] text-sm transition-colors w-fit">
                Social Media Klagenfurt
              </Link>
              <Link to={ROUTES.onlineMarketingGraz} className="block text-white/60 hover:text-[#4a9da8] text-sm transition-colors w-fit">
                Online-Marketing Graz
              </Link>
              <Link to={ROUTES.digitaleVermarktungWolfsberg} className="block text-white/60 hover:text-[#4a9da8] text-sm transition-colors w-fit">
                Digitale Vermarktung Wolfsberg
              </Link>
            </nav>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-base">Rechtliches</h3>
            <nav className="space-y-3" aria-label="Rechtliches">
              <Link to="/impressum" className="block text-white/60 hover:text-[#4a9da8] text-sm transition-colors w-fit">
                Impressum
              </Link>
              <Link to="/datenschutz" className="block text-white/60 hover:text-[#4a9da8] text-sm transition-colors w-fit">
                Datenschutz
              </Link>
            </nav>
          </div>
        </div>

        <div className="pt-8 mt-4 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm text-center sm:text-left order-2 sm:order-1">
            © {currentYear} Marmoris Studio. Alle Rechte vorbehalten.
          </p>
          <div className="flex gap-6 order-1 sm:order-2">
            <Link to="/impressum" className="text-white/50 hover:text-white/70 text-sm transition-colors">
              Impressum
            </Link>
            <Link to="/datenschutz" className="text-white/50 hover:text-white/70 text-sm transition-colors">
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
